export default () => 'Hello, World!';
